import { FC } from 'react'
import { Container, ContainerLarge } from '../../container'
import { TimelineVideo } from '../video'
import { ReadMore } from '../../read-more'
import {
  TimelineTitle,
  TimelineTitleMask,
  TimelineIntro,
  TimelineSubtitle,
  TimelineContent,
  TimelineImage,
  TimelineAnchor,
} from '../styled'
import { texts } from '../../locale'
type Props = {
  scrollUp: boolean
}
export const Chapter_8: FC<Props> = ({ scrollUp }) => {
  return (
    <>
      <TimelineTitle>
        <TimelineAnchor id="chapter-8" $scrollUp={scrollUp} />
        <TimelineTitleMask />
        <img
          src={
            'https://gdb.rferl.org/01000000-0aff-0242-102b-08db6d048e24_w1920_r4.jpg'
          }
        />
        <h2>
          <span>8</span>
          Літній наступ України
          <strong>{texts.menu_16}</strong>
        </h2>
      </TimelineTitle>

      <ContainerLarge>
        <TimelineIntro>
          Після важкої зими із втратою Соледара і майже всього Бахмута, Україна
          зібрала сили для наступу. Пізніше стане відомо, що тодішній
          головнокомандувач ЗСУ Валерій Залужний вважав за потрібне розпочати
          атаку раніше, однак Україна очікувала на прибуття критично необхідної
          зброї із Заходу. Насамперед, ішлося про «броньований кулак»: танки
          Leopard, Challenger, Abrams; БМП та БТРи. Ключовою причиною, чому
          наступ української армії не досяг того результату, на який
          розраховувало суспільство та уряди країн-партнерів, стало те, Росії
          вдалося звести за час зволікання Сил оборони на окупованому півдні
          багато ешелонів укріплень та мінних полів: так, їх бачили з космосу,
          проте не уявляли, якою перешкодою це стане в реальному бою. Тим не
          менше, 2023 рік Україна пройшла з територіальними здобутками. Їх
          Кремль з усіх сил намагається нівелювати, атакуючи тепер на цих
          ділянках.
        </TimelineIntro>

        <TimelineContent>
          <TimelineSubtitle>8-10 травня</TimelineSubtitle>
          <p>
            Сили оборони України вперше за час бахмутської оборонної операції
            повертають хід фронту у зворотному напрямку. Існують різні оцінки
            того, коли ЗСУ почали наступальні дії під Бахмутом (здебільшого
            йдеться про квітень), однак про перші результати командування
            повідомило саме у ці дні: російські війська відступили на глибину у
            2 кілометри. За даними 3-ї окремої штурмової бригади, яка
            відігравала головну роль у цих боях, були повністю розгромлені дві
            роти російської 72 мотострілецької бригади, ЗС РФ втратили двох
            полковників. Подальше просування захисників України відбувалося в
            районі Берхівки (північ від міста) та Кліщіївки (південь). У цей час
            ЗСУ рухалися вперед на флангах, а війська РФ усе ще наступали
            всередині міста.
          </p>

          <TimelineSubtitle>10-12 червня</TimelineSubtitle>
          <p>
            Просування ЗСУ починається і на півдні Донеччини та на Запоріжжі. В
            районі Великої Новосілки, що трохи західніше Вугледара, звільнені
            села Нескучне, Благодатне, Сторожеве, Макарівка, а також Новодарівка
            та Левадне поруч у Запорізькій області. На іншому фронті у
            Запорізькій області – ближче до річки Дніпро – звільнене Лобкове, з
            чого починається рух армії України на південь.
          </p>
          <TimelineVideo id={'xLgJb1RKO8s'} />

          <TimelineSubtitle>19 червня</TimelineSubtitle>
          <p>На Запорізькому фронті звільнено П’ятихатки.</p>

          <TimelineSubtitle>26-27 червня</TimelineSubtitle>
          <p>
            Сили оборони України звільняють Рівнопіль та Старомайорське на
            великоновосілківській ділянці.
          </p>

          <TimelineSubtitle>16 серпня</TimelineSubtitle>
          <p>
            Там же звільняють село Урожайне. За результатами літнього наступу на
            стику Донецької та Запорізької областей утворюється звільнена
            ділянка площею 243 квадратних кілометри.
          </p>
          <TimelineVideo id={'DYJ7GjupFRo'} />

          <TimelineSubtitle>23 серпня</TimelineSubtitle>
          <p>
            На південному фронті, у Запорізькій області, звільнене село
            Роботине. Цей населений пункт став опорою українських військ на весь
            подальший період. Вважалося, що далі наступ буде розвиватися у
            напрямку Токмака і Мелітополя, проте Україні не вдалося подолати
            потужну лінію ешелонованих фортифікацій, зведених тут Росією.
            Пізніше військові аналітики та головком Валерій Залужний
            акцентуватимуть: Росія виграла час на облаштування мінних полів
            небачених масштабів.{' '}
            <a href="https://www.radiosvoboda.org/a/32685416.html">Тут</a>{' '}
            читайте про те, чому ця лінія так шокувала світ, і що з нею робити.
            Площа звільнених на цьому напрямку територій влітку склала близько
            135 квадратних кілометрів.
          </p>
          <TimelineVideo id={'EFADe0dRND0'} />

          <TimelineSubtitle>15-17 вересня</TimelineSubtitle>
          <p>
            В результаті наступальної кампанії Сили оборони України відновили
            свої позиції у двох найважливіших точках на південь від Бахмута:
            Кліщіївці та Андріївці.
          </p>

          <TimelineSubtitle>вересень 2023-лютий 2024</TimelineSubtitle>
          <p>
            Україна активізує удари по російських військових кораблях та
            військовій інфраструктурі РФ в окупованому Криму. За цей період
            ударами крилатих ракет та морских дронів знищено великі десантні
            кораблі «Новочеркасск», «Минск», «Цезарь Куников», катери «Серна»,
            «Акула» та «Ивановец», уражено підводний човен «Ростов-на-Дону»,
            корабель-розвідник «Іван Хурс», патрульний корабель «Сергій Котов»
            (це неповний перелік уражених кораблів ЧФ РФ). Це змусило російський
            флот залишити північно-західну акваторію Чорного моря, тим самим був
            розблокований експорт українського зерна з українських портів. У той
            же час в рази зменшились пуски крилатих ракет морського базування
            «Калібр» з Чорного моря, хоча ще у 2022 році їхні запуски були
            одними з наймасовіших під час ракетних атак. За підсумками 2023 року
            західні партнери заговорили про здобуття Україною перемоги на морі:
            «Панування росії у Чорному морі тепер під питанням», – висловився у
            грудні міністр оборони Великої Британії Грант Шаппс.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/01000000-0a00-0242-6c4b-08dc23229216_w1000.jpg'
              }
            />
            <span>
              Момент влучання морського дрону ГУР Міноборони України в катер
              «Ивановец» ЧФ Росії
            </span>
          </TimelineImage>

          <ReadMore>
            <p>
              Українські удари по Криму комплексні, адже націлені і на наземну
              інфраструктуру та управління угруповання російських військ на
              материковій Україні. Зокрема, 22 вересня ЗСУ уразили штаб
              Чорноморського флоту у Севастополі. У ті ж дні ракетного удару
              зазнав{' '}
              <a href="https://www.radiosvoboda.org/a/news-chf-rf-udar-suputnykovi-znimky/32602829.html">
                запасний командний пункт
              </a>{' '}
              ЧФ РФ, а 1 листопада – пункт управління російського угруповання
              військ «Днепр» на Арабатській стрілці. Наприкінці серпня 2023 року
              уражено частину зенітно-ракетного комплексу С-400 «Тріумф». Вже на
              початку 2024 року завдано удару по аеродрому «Бельбек». Перелік
              ударів суттєво ширший і з ним можна ознайомитися на інтерактивній{' '}
              <a href="https://www.radiosvoboda.org/a/crimea-military-bases-map/32397787.html?markerId=416">
                карті
              </a>{' '}
              Радіо Свобода.
            </p>
            <TimelineVideo id={'rcFLZ064IWg'} />

            <p>
              Постійне ураження військових об’єктів у Криму створює проблеми для
              управління російськими військами на лінії фронту вздовж Дніпра,
              залишає без прикриття важливі об’єкти у ближньому тилу російських
              військ та, в подальшому, може змусити переносити їх глибше у тил,
              що ускладнить їх координацію і забезпечення. Комбіновані удари із
              застосуванням ракет та дронів у 2024 році продовжуються.
            </p>
          </ReadMore>
        </TimelineContent>
      </ContainerLarge>
    </>
  )
}
